// @ts-nocheck

import PropTypes from 'prop-types';

const HeaderItem = ({ label, value }) => {
  return (
    <div>
      <h3 className='cancel-booking-modal-subtitle'>{label}</h3>
      <h3 className='cancel-booking-header-item'>{value}</h3>
    </div>
  );
};

HeaderItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

export default HeaderItem;
